import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as materialStyles from '../../../constants/materialstyle';

import {logout} from '../../../utils/auth';
import * as authActionCreators from '../../../actions/auth';

import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import NavigationMenu from 'material-ui/svg-icons/navigation/menu';


class HeaderMenu extends React.Component {
  
  static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  supportNav() {
    this.context.router.push('/support');
  }

  manualNav() {
    this.context.router.push('/manual');
  }

  logoutUser() {
    logout();
    this.props.authClear();
    this.context.router.push('/login');
  }

  supportNav() {
    this.context.router.push('/support');
  }

  render() {
    return <IconMenu
      iconButtonElement={
        <IconButton iconStyle={{width: '30px', height: '30px'}}><NavigationMenu color='#FFFFFF' /></IconButton>
      }
      targetOrigin={{horizontal: 'right', vertical: 'top'}}
      anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}>
      <MenuItem 
        primaryText="Support"
        hoverColor='#0000FF'
        onTouchTap={::this.supportNav} />
      <MenuItem 
        primaryText="Training Manual"
        hoverColor='#0000FF'
        onTouchTap={::this.manualNav} />
      <MenuItem 
        primaryText="Log out"
        hoverColor='#0000FF'
        onTouchTap={::this.logoutUser} />
    </IconMenu>
  }
}
export default HeaderMenu;

function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}

export const HeaderMenuContainer = connect(
  mapStateToProps,
  authActionCreators
)(HeaderMenu);


// WEBPACK FOOTER //
// ./src/components/views/header/HeaderMenu.jsx